function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { EventEmitter } from 'eventemitter3';
export class TextEditor extends EventEmitter {
  constructor(camera) {
    super();
    _defineProperty(this, "rootView", void 0);
    _defineProperty(this, "content", void 0);
    _defineProperty(this, "camera", void 0);
    _defineProperty(this, "originX", 0);
    _defineProperty(this, "originY", 0);
    _defineProperty(this, "rotation", 0);
    _defineProperty(this, "scale", 1);
    _defineProperty(this, "handleContentInput", () => {
      this.emit('change', this.content.textContent ?? '');
      this.translateCaretIntoView();
    });
    _defineProperty(this, "handleContentKeydown", evt => {
      if (/^Arrow/.test(evt.key)) {
        setTimeout(() => {
          this.translateCaretIntoView();
        }, 50);
      }
    });
    _defineProperty(this, "handleContentBlur", () => {
      this.emit('done', this.content.textContent ?? '');
    });
    _defineProperty(this, "handleRootClick", evt => {
      if (evt.target === this.rootView) {
        evt.stopPropagation();
        evt.preventDefault();
        this.emit('done', this.content.textContent ?? '');
      }
    });
    this.camera = camera;
    this.rootView = document.createElement('div');
    this.rootView.style.cssText = 'position:absolute;width:100%;height:100%;top:0;left:0;overflow:clip;';
    this.content = document.createElement('div');
    this.content.setAttribute('spellcheck', 'false');
    this.content.textContent = '';
    this.content.setAttribute('contenteditable', 'plaintext-only');
    // canvas 默认行高是 1.2em
    this.content.style.cssText = 'white-space: nowrap;border:1px solid red;text-wrap:nowrap;caret-color:red;line-height:1.2em;position:absolute;z-index:2;color:transparent;outline:none;';
    this.content.style.transformOrigin = '0 0';
    this.rootView.appendChild(this.content);
    this.content.addEventListener('input', this.handleContentInput);
    this.content.addEventListener('blur', this.handleContentBlur);
    this.content.addEventListener('keydown', this.handleContentKeydown);
    this.rootView.addEventListener('pointerdown', this.handleRootClick);
    this.camera.on('zoom', matrix => {
      this.scale = matrix.scaling.x;
      this.updateMatrixStyle();
    });
  }
  // 通过移动相机, 使光标在可见区域内
  translateCaretIntoView() {
    const selection = window.getSelection();
    if (selection) {
      const range = selection.getRangeAt(0);
      const caretRect = range.getBoundingClientRect();
      const rootRect = this.rootView.getBoundingClientRect();
      const contentRect = this.content.getBoundingClientRect();
      const PADDING = 33;
      if (Math.abs(caretRect.x - (rootRect.x + rootRect.width)) <= 12) {
        this.camera.translate(-contentRect.width, 0);
      } else if (Math.abs(caretRect.x - (rootRect.x + rootRect.width)) <= PADDING) {
        this.camera.translate(-PADDING * 2, 0);
      } else if (caretRect.x < 0) {
        this.camera.translate(-caretRect.x + PADDING * 2, 0);
      } else if (caretRect.x <= PADDING) {
        this.camera.translate(PADDING * 2, 0);
      }
    }
  }
  setContent(content) {
    this.content.textContent = content;
  }
  updateMatrixStyle() {
    const viewPoint = this.camera.scope.project.view.projectToView([this.originX, this.originY]);
    console.log('updateMatrixStyle', this.originX, this.originY, viewPoint);
    this.content.style.top = `${viewPoint.y}px`;
    this.content.style.left = `${viewPoint.x}px`;
    this.content.style.transform = `rotate(${this.rotation}deg) scale(${this.scale})`;
  }
  setOrigin(x, y) {
    this.originX = x;
    this.originY = y;
    this.updateMatrixStyle();
  }
  setRotate(angle) {
    this.rotation = angle;
    this.updateMatrixStyle();
  }
  setFontSize(value) {
    this.content.style.fontSize = `${value}px`;
  }
  setFontFamily(value) {
    this.content.style.fontFamily = value;
  }
  focus() {
    this.content.focus();
  }
  setCaret() {
    const range = document.createRange();
    const selection = window.getSelection();
    range.setStart(this.content.childNodes[0], this.content.textContent?.length ?? 0);
    // range.collapse(true);
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
  dispose() {
    this.removeAllListeners('done');
    this.removeAllListeners('change');
    this.content.removeEventListener('input', this.handleContentInput);
    this.content.removeEventListener('blur', this.handleContentBlur);
    this.rootView.removeEventListener('pointerdown', this.handleRootClick);
  }
}